<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Collection Places / Registrations' | translate}}
            <span (click)="switchHeadings()"
                  class="addBtn services-icon--add ml-2"
                  style="position:relative;top:-5px;">Turn Table</span>
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <section class="table-container cross-table-container">
                    <section class="table-flip-scroll">
                        <table class="table table-bordered table-striped cross-table">
                            <thead>
                                <tr>
                                    <th>Value</th>
                                    <th *ngFor="let column of serviceLocationRegistrationRelations[0]; let i = index; ">
                                        <span *ngIf="!tableSwitched"
                                              class="limited"
                                              title="{{column.registrationName}}">
                                            {{column?.registrationShortName && column?.registrationShortName !== "" ? column?.registrationShortName : column?.registrationName}}
                                        </span>
                                        <span *ngIf="tableSwitched"
                                              class="limited"
                                              title="{{column.serviceLocationName}}">
                                            {{column.serviceLocationName}}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of serviceLocationRegistrationRelations; let i = index;">
                                    <td *ngIf="!tableSwitched">
                                        <span class="limited wider" title="{{row[0].serviceLocationName}}">
                                            {{row[0]?.registrationShortName && row[0]?.registrationShortName !== "" ? row[0]?.registrationShortName : row[0]?.registrationName}}
                                        </span>
                                    </td>
                                    <td *ngIf="tableSwitched">
                                        <span class="limited wider" title="{{row[0].registrationName}}">{{row[0].registrationName}}</span>
                                    </td>
                                    <td *ngFor="let col of row; let j = index;">
                                        <i class="fas {{ col.registrationHasLocation ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled' }}"
                                           style="vertical-align:middle;"
                                           (click)="editServiceLocationRegistrationEvent(col)"></i>
                                        <div *ngIf="col?.determinants && col?.determinants.length > 0">
                                            <ul class="list-unstyled">
                                                <li class="text-muted"
                                                    *ngFor="let det of col?.determinants">
                                                    <span *ngIf="det">{{ 'general.if' | translate }} {{det.name}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </section>
            </div>
        </div>
    </div>
</app-service-detail>